const Logo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="176.939"
      height={16}
      viewBox="0 0 176.939 16"
    >
      <g id="Logo" transform="translate(-0.001 0)">
        <path
          id="Path_32806"
          data-name="Path 32806"
          d="M14.687,3.209,13.5,4.131a6.5,6.5,0,0,0-2.354-1.962A6.809,6.809,0,0,0,8.13,1.5a6.6,6.6,0,0,0-3.33.875A6.237,6.237,0,0,0,2.426,4.726a6.574,6.574,0,0,0-.843,3.319A6.275,6.275,0,0,0,3.467,12.7,6.482,6.482,0,0,0,8.222,14.56,6.649,6.649,0,0,0,13.5,12.053l1.185.911a7.593,7.593,0,0,1-2.8,2.242A8.693,8.693,0,0,1,8.13,16a7.757,7.757,0,0,1-6.22-2.661A8.1,8.1,0,0,1,0,7.911,7.6,7.6,0,0,1,2.313,2.282,7.917,7.917,0,0,1,8.11,0a8.409,8.409,0,0,1,3.8.844,7.4,7.4,0,0,1,2.778,2.366"
          transform="translate(0.001 0.001)"
        />
        <path
          id="Path_32807"
          data-name="Path 32807"
          d="M160.845,2.881l7.007,15.244H166.23l-2.363-5.016h-6.473l-2.34,5.016h-1.675l7.1-15.244Zm-.19,3.239-2.574,5.518h5.136Z"
          transform="translate(-133.261 -2.503)"
        />
        <path
          id="Path_32808"
          data-name="Path 32808"
          d="M304.811,18.125l2.151-15.244h.244l6.107,12.508,6.049-12.508h.241l2.162,15.244h-1.473l-1.484-10.9-5.312,10.9h-.384L307.737,7.14l-1.476,10.985Z"
          transform="translate(-265.095 -2.504)"
        />
        <rect
          id="Rectangle_155"
          data-name="Rectangle 155"
          width="1.501"
          height="15.244"
          transform="translate(63.45 0.378)"
        />
        <path
          id="Path_32809"
          data-name="Path 32809"
          d="M556.115,2.881h1.5V16.654H563.4v1.471h-7.282Z"
          transform="translate(-483.628 -2.503)"
        />
        <path
          id="Path_32810"
          data-name="Path 32810"
          d="M658.332,2.881h1.5V16.654h5.781v1.471h-7.282Z"
          transform="translate(-572.522 -2.503)"
        />
        <path
          id="Path_32811"
          data-name="Path 32811"
          d="M757.89,2.881,764.9,18.125h-1.622l-2.363-5.016H754.44l-2.34,5.016h-1.675l7.1-15.244ZM757.7,6.12l-2.575,5.518h5.137Z"
          transform="translate(-652.637 -2.503)"
        />
        <path
          id="Path_32812"
          data-name="Path 32812"
          d="M979.7,2.881h2.993a17,17,0,0,1,3.473.228,3.76,3.76,0,0,1,2.921,3.834,3.88,3.88,0,0,1-.8,2.513,3.911,3.911,0,0,1-2.2,1.332,19.141,19.141,0,0,1-3.82.249H981.2v7.088h-1.5Zm1.5,1.492V9.544l2.543.031A6.563,6.563,0,0,0,986,9.291a2.323,2.323,0,0,0,1.124-.92,2.58,2.58,0,0,0,.408-1.422,2.544,2.544,0,0,0-.408-1.4,2.263,2.263,0,0,0-1.078-.905,6.4,6.4,0,0,0-2.191-.269Z"
          transform="translate(-852.008 -2.503)"
        />
        <rect
          id="Rectangle_156"
          data-name="Rectangle 156"
          width="1.501"
          height="15.244"
          transform="translate(142.518 0.378)"
        />
        <path
          id="Path_32813"
          data-name="Path 32813"
          d="M1163.963,2.881h1.5V9.275h7.65V2.881h1.5V18.125h-1.5V10.767h-7.65v7.358h-1.5Z"
          transform="translate(-1012.359 -2.503)"
        />
        <path
          id="Path_32814"
          data-name="Path 32814"
          d="M1301.609,2.881h1.5V16.654h5.781v1.471h-7.282Z"
          transform="translate(-1131.952 -2.503)"
        />
      </g>
    </svg>
  );
};

export default Logo;
